import { inject, Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { combineLatest, fromEvent } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import {
	BREAKPOINT_LG, BREAKPOINT_MD, BREAKPOINT_SM, BREAKPOINT_XL,
	MENU_WIDTH_AT_BREAKPOINT_LG, MENU_WIDTH_AT_BREAKPOINT_MD, MENU_WIDTH_AT_BREAKPOINT_SM, MENU_WIDTH_AT_BREAKPOINT_XL, MENU_WIDTH_AT_BREAKPOINT_XS
} from '../layout/dashboard-layout-constants';
import { ideasAndBugsMenu } from './menus/ideas-and-bugs-menu';
import { DashboardMenuItem } from '../../frame/dashboard-frame-config';
import { DashboardFrameService } from '../../frame/dashboard-frame.service';



@Injectable({ providedIn: 'root' })
export class DashboardMenuService {

	private dashboardFrameService = inject(DashboardFrameService);

	public menuItems = signal<DashboardMenuItem[]>([...this.dashboardFrameService.config().menu, ideasAndBugsMenu]);
	private readonly _menuCollapsed = signal<boolean>(false);
	public readonly menuCollapsed = this._menuCollapsed.asReadonly();
	private readonly _menuWidth = signal<number>(
		this.calcMenuWidth(window)
	);
	public readonly menuWidth = this._menuWidth.asReadonly();


	constructor() {
		//
		// Listen for the window resizing
		//
		const resize$ = fromEvent(window, 'resize')
			.pipe(
				startWith({ target: window }),
			);

		combineLatest([resize$, toObservable(this.menuCollapsed)])
			.pipe(
				map(([e, menuCollapsed]) => this.calcMenuWidth(e.target as Window)),
			)
			.subscribe(width => this._menuWidth.set(width));

	}


	/**
	 * Given the width of the window, determine what the CSS will set the left menu's width to.
	 */
	public calcMenuWidth(window: Window): number {
		const w = window.innerWidth;

		//
		// Menu is forced to small size when collapsed
		//
		if (w >= BREAKPOINT_SM && this.menuCollapsed()) return MENU_WIDTH_AT_BREAKPOINT_SM;

		if (w >= BREAKPOINT_XL) return MENU_WIDTH_AT_BREAKPOINT_XL;
		if (w >= BREAKPOINT_LG) return MENU_WIDTH_AT_BREAKPOINT_LG;
		if (w >= BREAKPOINT_MD) return MENU_WIDTH_AT_BREAKPOINT_MD;
		if (w >= BREAKPOINT_SM) return MENU_WIDTH_AT_BREAKPOINT_SM;
		return MENU_WIDTH_AT_BREAKPOINT_XS;
	}


	public setMenuCollapsed(isCollapsed: boolean) {
		if (this._menuCollapsed() == isCollapsed) return;
		this._menuCollapsed.set(isCollapsed);
	}


	public toggleCollapsed() {
		this.setMenuCollapsed(!this.menuCollapsed());
	}

}
